module.exports = __webpack_public_path__ + "static/media/image@2x.610c0533.png";